module.exports = __webpack_public_path__ + "img/logoicono.bff55f47.png";